var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bodyconter"},_vm._l((_vm.datalist),function(i,k){return _c('div',{key:k,staticClass:"neiqu"},[_c('div',{staticClass:"titlename"},[_vm._v(_vm._s(i.newsTitle))]),_c('div',{staticClass:"tiem"},[_vm._v("发布时间："+_vm._s(i.createTime))]),_c('img',{staticClass:"img1",attrs:{"src":i.img,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }